/**
 * Fair Work Knowledge Base - same component / styling as the ATO KB,
 * just scoped to the "fair-work" domain. Lists the indexed pay guide
 * PDFs (categories, document type filter, table+grid views, chunk viewer,
 * upload). Per the user request, structure and styles match ATO exactly.
 */

import { GlobalKnowledgeBasePage } from './GlobalKnowledgeBasePage';

export function FairWorkKnowledgeBasePage() {
  return <GlobalKnowledgeBasePage domainSlug="fair-work" />;
}

export default FairWorkKnowledgeBasePage;
